module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-container', {
    attrs: {
      "id": "nhMainPhone"
    }
  }, [_c('div', {
    staticClass: "topButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n            ")])], 1), _vm._v(" "), _c('el-main', {
    staticClass: "phoneMainBox"
  }, [_c('el-tabs', {
    attrs: {
      "tab-position": _vm.tabPosition
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 实习信息")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" 实习信息")])]), _vm._v(" "), _c('el-carousel', {
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "interval": 5000,
      "arrow": "never"
    }
  }, [(_vm.notificationData.length > 4) ? _c('div', _vm._l((4), function(index) {
    return _c('el-carousel-item', {
      key: index,
      nativeOn: {
        "click": function($event) {
          return _vm.notificationDetail(_vm.notificationData[index - 1])
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.notificationData[index - 1].title))])])
  }), 1) : _c('div', _vm._l((_vm.notificationData), function(item, index) {
    return _c('el-carousel-item', {
      key: item,
      nativeOn: {
        "click": function($event) {
          return _vm.notificationDetail(item)
        }
      }
    }, [
      [_c('h3', [_vm._v(_vm._s(item.title))])]
    ], 2)
  }), 1), _vm._v(" "), (_vm.notificationData.length > 4) ? _c('el-button', {
    staticStyle: {
      "position": "absolute",
      "z-index": "999",
      "right": "6vh",
      "bottom": "-4px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.moreNotification
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "15px",
      "color": "white"
    }
  }, [_vm._v("・・・")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "iconBtnGroup"
  }, [_c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.info
    }
  }, [_c('i', {
    staticClass: "el-icon-receiving"
  }), _vm._v(" "), _c('p', [_vm._v("个人实习信息")])]), _vm._v(" "), _c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.apply
    }
  }, [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" "), _c('p', [_vm._v("自主联系申请")])]), _vm._v(" "), _c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" "), _c('p', [_vm._v("实习变更申请")])]), _vm._v(" "), _c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.complete
    }
  }, [_c('i', {
    staticClass: "el-icon-edit-outline"
  }), _vm._v(" "), _c('p', [_vm._v("信息补全")])]), _vm._v(" "), _c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.report
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('p', [_vm._v("实习报告")])]), _vm._v(" "), _c('div', {
    staticClass: "iconBtn",
    on: {
      "click": _vm.evaluation
    }
  }, [_c('i', {
    staticClass: "el-icon-pie-chart"
  }), _vm._v(" "), _c('p', [_vm._v("成绩评定")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle twoTitle"
  }, [_c('h3', [_vm._v("共享文件")])]), _vm._v(" "), _c('div', {
    staticClass: "phoneList"
  }, [_c('div', {
    staticClass: "phoneListCard"
  }, _vm._l((_vm.fileData), function(item, index) {
    return _c('div', {
      staticClass: "listCard"
    }, [_c('div', {
      staticClass: "listCardText"
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "title": "",
        "column": 1
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "文件名"
      }
    }, [_vm._v(_vm._s(item.fileName) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "listCardBtn"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.fileDownload(item)
        }
      }
    }, [_vm._v("下载\n                                        ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.fileShow(item)
        }
      }
    }, [_vm._v("预览\n                                        ")])], 1)])
  }), 0)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-notebook-1"
  }), _vm._v(" 实习周记")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-notebook-1"
  }), _vm._v(" 实习周记")])]), _vm._v(" "), _c('div', {
    staticClass: "phoneList"
  }, [_c('div', {
    staticClass: "phoneListCard"
  }, _vm._l((_vm.summaryData), function(item, index) {
    return _c('div', {
      staticClass: "listCard"
    }, [_c('div', {
      staticClass: "listCardText"
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "title": "",
        "column": 1
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "时间范围"
      }
    }, [_vm._v(_vm._s(_vm.timeRangeFormatter(item)) + "\n                                            ")]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "提交状态"
      }
    }, [_vm._v(_vm._s(_vm.submitStateFormatter(item)) + "\n                                            ")]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "评阅状态"
      }
    }, [_vm._v(_vm._s(_vm.evaluateStateFormatter(item)) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "listCardBtn"
    }, [(item.submitState === '0' || item.submitState == '') ? _c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.summaryEdit(item)
        }
      }
    }, [_vm._v("编辑\n                                        ")]) : _vm._e(), _vm._v(" "), (item.submitState === '1') ? _c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.summaryDetail(item)
        }
      }
    }, [_vm._v("详情\n                                        ")]) : _vm._e()], 1)])
  }), 0)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "third"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" 现场指导")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" 现场指导")])]), _vm._v(" "), _c('div', {
    staticClass: "phoneList"
  }, [_c('div', {
    staticClass: "phoneListCard"
  }, _vm._l((_vm.guidanceData), function(item, index) {
    return _c('div', {
      staticClass: "listCard"
    }, [_c('div', {
      staticClass: "listCardText"
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "title": "",
        "column": 1
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "指导老师"
      }
    }, [_vm._v(_vm._s(item.teaName) + "\n                                            ")]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "指导时间"
      }
    }, [_vm._v(_vm._s(item.time) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "listCardBtn"
    }, [_c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.guidanceDetail(item)
        }
      }
    }, [_vm._v("详情\n                                        ")])], 1)])
  }), 0)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "four"
    }
  }, [_c('span', {
    staticClass: "tabTitleBox",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" 返校记录")]), _vm._v(" "), _c('div', {
    staticClass: "phoneMain"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('h3', [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" 返校记录")])]), _vm._v(" "), _c('div', {
    staticClass: "phoneList"
  }, [_c('div', {
    staticClass: "phoneListCard"
  }, _vm._l((_vm.homecomingData), function(item, index) {
    return _c('div', {
      staticClass: "listCard"
    }, [_c('div', {
      staticClass: "listCardText"
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "title": "",
        "column": 1
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "返校时间"
      }
    }, [_vm._v(_vm._s(item.time) + "\n                                            ")]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "出勤状态"
      }
    }, [_vm._v(_vm._s(_vm.parseAttendance(item)) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "listCardBtn"
    }, [_c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.homecomingDetail(item)
        }
      }
    }, [_vm._v("详情\n                                        ")])], 1)])
  }), 0)])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "个人实习信息",
      "visible": _vm.infoDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.infoDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "infoDialogScroll",
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.user.userCode) + " - " + _vm._s(_vm.user.userName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习单位名称"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习岗位名称"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.postName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生手机号"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.stuPhone) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家庭电话"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.homeTel) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习推荐类型"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parsePracticeType(_vm.stuPracticeInfo.typeCode)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习薪资"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.salary) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入学前户籍信息"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.censusRegisterInfo) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习期间居住地址"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.residentialAddress) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习开始时间"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.beginTime) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习结束时间"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.endTime) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生邮箱"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.stuEmail) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供住宿"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseSf(_vm.stuPracticeInfo.putUp)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否岗位对口"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseSf(_vm.stuPracticeInfo.counterpart)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否安排带教"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseSf(_vm.stuPracticeInfo.teaching)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitContactsName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人职务"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitContactsDuty) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人电话"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitContactsTel) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人邮箱"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitContactsEmail) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位地址"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.unitAddress) + "\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "visible": _vm.applyListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.applyListDialogVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("自主联系申请")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#67C23A",
      "border": "none",
      "margin-left": "10px",
      "width": "50px",
      "height": "30px"
    },
    on: {
      "click": _vm.newApply
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("申请")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "height": "65vh"
    },
    attrs: {
      "id": "listArea"
    }
  }, _vm._l((_vm.applyData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("单位名称")]), _vm._v(_vm._s(item.unitName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("岗位名称")]), _vm._v(_vm._s(item.postName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("创建时间")]), _vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '0' && item.auditState != '2') ? _c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.applyMod(item, 'set');
        }
      }
    }, [_vm._v("编辑\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '0' && item.auditState != '2') ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.applyDel(item);
        }
      }
    }, [_vm._v("删除\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState == '2') ? _c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.applyMod(item, 'view');
        }
      }
    }, [_vm._v("详情\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState == '1' || item.auditState == '2') ? _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.showAuditList(item.id);
        }
      }
    }, [_vm._v("审核信息\n                            ")]) : _vm._e()], 1)])
  }), 0)], 2), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.auditRelatedCode,
      "listHeight": 450
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.applyDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "visible": _vm.applyDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.applyDialogVisible = $event
      },
      "closed": _vm.closeApply
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.applyDialogTitle))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.applySubmitStr))]), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.applyAuditStrColor,
      'margin-left': '10px'
    })
  }, [_vm._v(_vm._s(_vm.applyAuditStr))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "white",
      "border-width": "1px",
      "border-color": "#D3D3D3",
      "margin-left": "10px",
      "width": "70px",
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.showAuditList(_vm.applyForm.id)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#606266"
    }
  }, [_vm._v("审核信息")])])]), _vm._v(" "), _c('el-scrollbar', {
    ref: "infoDialogScroll",
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    ref: "applyForm",
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%",
      "model": _vm.applyForm,
      "rules": _vm.applyRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.applyForm.stuName + ' - ' + _vm.applyForm.stuCode) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入学前户籍信息",
      "prop": "censusRegisterInfo"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "200"
    },
    model: {
      value: (_vm.applyForm.censusRegisterInfo),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "censusRegisterInfo", $$v)
      },
      expression: "applyForm.censusRegisterInfo"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.censusRegisterInfo))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习期间居住地址",
      "prop": "residentialAddress"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "200"
    },
    model: {
      value: (_vm.applyForm.residentialAddress),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "residentialAddress", $$v)
      },
      expression: "applyForm.residentialAddress"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.residentialAddress))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家庭电话",
      "prop": "homeTel"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.homeTel),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "homeTel", $$v)
      },
      expression: "applyForm.homeTel"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.homeTel))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生手机号",
      "prop": "stuPhone"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.stuPhone),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "stuPhone", $$v)
      },
      expression: "applyForm.stuPhone"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.stuPhone))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生邮箱",
      "prop": "stuEmail"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.applyForm.stuEmail),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "stuEmail", $$v)
      },
      expression: "applyForm.stuEmail"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.stuEmail))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习单位名称",
      "prop": "unitName"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "200"
    },
    model: {
      value: (_vm.applyForm.unitName),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitName", $$v)
      },
      expression: "applyForm.unitName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习岗位名称",
      "prop": "postName"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.postName),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "postName", $$v)
      },
      expression: "applyForm.postName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.postName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习开始时间",
      "prop": "beginTime"
    }
  }, [(_vm.applyFlag) ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.applyForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "beginTime", $$v)
      },
      expression: "applyForm.beginTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.beginTime))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习结束时间",
      "prop": "endTime"
    }
  }, [(_vm.applyFlag) ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.applyForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "endTime", $$v)
      },
      expression: "applyForm.endTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.endTime))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习薪资",
      "prop": "salary"
    }
  }, [(_vm.applyFlag) ? _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "precision": 2,
      "step": 10,
      "min": 0,
      "max": 1000000
    },
    model: {
      value: (_vm.applyForm.salary),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "salary", $$v)
      },
      expression: "applyForm.salary"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.salary))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否岗位对口",
      "prop": "counterpart"
    }
  }, [(_vm.applyFlag) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.applyForm.counterpart),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "counterpart", $$v)
      },
      expression: "applyForm.counterpart"
    }
  }, _vm._l((_vm.comboOption.sf), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.parseSf(_vm.applyForm.counterpart)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否安排带教",
      "prop": "teaching"
    }
  }, [(_vm.applyFlag) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.applyForm.teaching),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "teaching", $$v)
      },
      expression: "applyForm.teaching"
    }
  }, _vm._l((_vm.comboOption.sf), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.parseSf(_vm.applyForm.teaching)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否提供住宿",
      "prop": "putUp"
    }
  }, [(_vm.applyFlag) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.applyForm.putUp),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "putUp", $$v)
      },
      expression: "applyForm.putUp"
    }
  }, _vm._l((_vm.comboOption.sf), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.parseSf(_vm.applyForm.putUp)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人姓名",
      "prop": "unitContactsName"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.unitContactsName),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitContactsName", $$v)
      },
      expression: "applyForm.unitContactsName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitContactsName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人职务",
      "prop": "unitContactsDuty"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.unitContactsDuty),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitContactsDuty", $$v)
      },
      expression: "applyForm.unitContactsDuty"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitContactsDuty))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人电话",
      "prop": "unitContactsTel"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.applyForm.unitContactsTel),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitContactsTel", $$v)
      },
      expression: "applyForm.unitContactsTel"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitContactsTel))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位联系人邮箱",
      "prop": "unitContactsEmail"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.applyForm.unitContactsEmail),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitContactsEmail", $$v)
      },
      expression: "applyForm.unitContactsEmail"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitContactsEmail))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位地址",
      "prop": "unitAddress"
    }
  }, [(_vm.applyFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.applyForm.unitAddress),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "unitAddress", $$v)
      },
      expression: "applyForm.unitAddress"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.applyFlag) ? _c('span', [_vm._v(_vm._s(_vm.applyForm.unitAddress))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.applyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.applySave
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.applyFlag) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.applySubmit
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.applyDelFlag) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.applyDel
    }
  }, [_vm._v("删 除")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.applyDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "visible": _vm.changeDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.changeDialogVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v("实习变更申请")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background-color": "#67C23A",
      "border": "none",
      "margin-left": "10px",
      "width": "50px",
      "height": "30px"
    },
    on: {
      "click": _vm.newChange
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#FFFFFF"
    }
  }, [_vm._v("申请")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px 20px",
      "height": "65vh"
    },
    attrs: {
      "id": "listArea"
    }
  }, _vm._l((_vm.changeData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("单位名称")]), _vm._v(_vm._s(item.unitName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("岗位名称")]), _vm._v(_vm._s(item.postName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("创建时间")]), _vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.changeMod(item, 'set');
        }
      }
    }, [_vm._v("编辑\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.changeDel(item);
        }
      }
    }, [_vm._v("删除\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1') ? _c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.changeMod(item, 'view');
        }
      }
    }, [_vm._v("详情\n                            ")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState == '1' || item.auditState == '2') ? _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.showAuditList(item.id);
        }
      }
    }, [_vm._v("审核信息\n                            ")]) : _vm._e()], 1)])
  }), 0)], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": _vm.addChangeDialogTitle,
      "visible": _vm.addChangeDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addChangeDialogVisible = $event
      },
      "closed": _vm.closeAddChange
    }
  }, [_c('el-scrollbar', {
    ref: "infoDialogScroll",
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    ref: "changeForm",
    attrs: {
      "label-width": "140px",
      "label-position": "left",
      "width": "100%",
      "model": _vm.changeForm,
      "rules": _vm.changeRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuPracticeInfo.stuName + ' - ' + _vm.stuPracticeInfo.stuCode) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习单位名称"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习单位名称",
      "prop": "newUnitName"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "200"
    },
    model: {
      value: (_vm.changeForm.newUnitName),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitName", $$v)
      },
      expression: "changeForm.newUnitName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习岗位名称"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.postName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习岗位名称",
      "prop": "newPostName"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.changeForm.newPostName),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newPostName", $$v)
      },
      expression: "changeForm.newPostName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newPostName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习开始时间"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.beginTime) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习开始时间",
      "prop": "newBeginTime"
    }
  }, [(_vm.changeFlag) ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.changeForm.newBeginTime),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newBeginTime", $$v)
      },
      expression: "changeForm.newBeginTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newBeginTime))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习结束时间"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.endTime) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习结束时间",
      "prop": "newEndTime"
    }
  }, [(_vm.changeFlag) ? _c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.changeForm.newEndTime),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newEndTime", $$v)
      },
      expression: "changeForm.newEndTime"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newEndTime))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原实习薪资"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.salary) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现实习薪资",
      "prop": "newSalary"
    }
  }, [(_vm.changeFlag) ? _c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "precision": 2,
      "step": 10,
      "min": 0,
      "max": 1000000
    },
    model: {
      value: (_vm.changeForm.newSalary),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newSalary", $$v)
      },
      expression: "changeForm.newSalary"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newSalary))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原是否岗位对口"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseSf(_vm.changeForm.counterpart)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现是否岗位对口",
      "prop": "newCounterpart"
    }
  }, [(_vm.changeFlag) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.changeForm.newCounterpart),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newCounterpart", $$v)
      },
      expression: "changeForm.newCounterpart"
    }
  }, _vm._l((_vm.comboOption.sf), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.parseSf(_vm.changeForm.newCounterpart)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原是否提供住宿"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseSf(_vm.changeForm.putUp)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现是否提供住宿",
      "prop": "newPutUp"
    }
  }, [(_vm.changeFlag) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.changeForm.newPutUp),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newPutUp", $$v)
      },
      expression: "changeForm.newPutUp"
    }
  }, _vm._l((_vm.comboOption.sf), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.parseSf(_vm.changeForm.newPutUp)))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人姓名"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitContactsName) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人姓名",
      "prop": "newUnitContactsName"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.changeForm.newUnitContactsName),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitContactsName", $$v)
      },
      expression: "changeForm.newUnitContactsName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitContactsName))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人职务"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitContactsDuty) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人职务",
      "prop": "newUnitContactsDuty"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.changeForm.newUnitContactsDuty),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitContactsDuty", $$v)
      },
      expression: "changeForm.newUnitContactsDuty"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitContactsDuty))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人电话"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitContactsTel) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人电话",
      "prop": "newUnitContactsTel"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.changeForm.newUnitContactsTel),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitContactsTel", $$v)
      },
      expression: "changeForm.newUnitContactsTel"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitContactsTel))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位联系人邮箱"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitContactsEmail) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位联系人邮箱",
      "prop": "newUnitContactsEmail"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.changeForm.newUnitContactsEmail),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitContactsEmail", $$v)
      },
      expression: "changeForm.newUnitContactsEmail"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitContactsEmail))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原单位地址"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.changeForm.unitAddress) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现单位地址",
      "prop": "newUnitAddress"
    }
  }, [(_vm.changeFlag) ? _c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.changeForm.newUnitAddress),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newUnitAddress", $$v)
      },
      expression: "changeForm.newUnitAddress"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.changeFlag) ? _c('span', [_vm._v(_vm._s(_vm.changeForm.newUnitAddress))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.changeFlag) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeSave
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.changeFlag) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.changeSubmit
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addChangeDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": "信息补全",
      "visible": _vm.completeDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.completeDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "infoDialogScroll",
    staticStyle: {
      "height": "35vh"
    },
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.completeForm.stuName + ' - ' + _vm.completeForm.stuCode) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实习期间居住地址",
      "prop": "residentialAddress"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "200"
    },
    model: {
      value: (_vm.completeForm.residentialAddress),
      callback: function($$v) {
        _vm.$set(_vm.completeForm, "residentialAddress", $$v)
      },
      expression: "completeForm.residentialAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "家庭电话",
      "prop": "homeTel"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.completeForm.homeTel),
      callback: function($$v) {
        _vm.$set(_vm.completeForm, "homeTel", $$v)
      },
      expression: "completeForm.homeTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生手机号",
      "prop": "stuPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: (_vm.completeForm.stuPhone),
      callback: function($$v) {
        _vm.$set(_vm.completeForm, "stuPhone", $$v)
      },
      expression: "completeForm.stuPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生邮箱",
      "prop": "stuEmail"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.completeForm.stuEmail),
      callback: function($$v) {
        _vm.$set(_vm.completeForm, "stuEmail", $$v)
      },
      expression: "completeForm.stuEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.completeSave
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.completeDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), (_vm.reportListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "实习报告",
      "visible": _vm.reportListDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.reportListDialogVisible = $event
      },
      "close": _vm.delFile
    }
  }, [_c('div', {
    ref: "infoDialogScroll",
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('report', {
    ref: "report",
    staticStyle: {
      "margin-top": "10px",
      "height": "50vh"
    },
    attrs: {
      "stu-code": _vm.user.userCode,
      "user-type": "stu",
      "type": "mobile",
      "previewDialogWidth": "90%"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.evaluationDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "成绩评定",
      "visible": _vm.evaluationDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.evaluationDialogVisible = $event
      }
    }
  }, [(_vm.evaluationState) ? _c('el-form', {
    attrs: {
      "label-width": "0px",
      "label-position": "left"
    }
  }, [_c('table', {
    staticClass: "configArea"
  }, [_c('tr', {
    staticStyle: {
      "border-bottom": "1px solid #EBEEF5",
      "border-top": "1px solid #EBEEF5"
    }
  }, [(_vm.evaluationState) ? _c('td', [_c('el-form-item', [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#606266",
      "font-weight": "bold",
      "padding-left": "10px"
    }
  }, [_vm._v("总分")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "padding-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.evaluationCountScore))])])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px",
      "overflow": "auto",
      "padding": "10px 20px"
    }
  }, [(_vm.evaluationState) ? _c('el-container', {
    staticClass: "register-container"
  }, [_c('el-container', [_c('el-aside', {
    attrs: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "config-container"
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px",
      "label-position": "left"
    }
  }, _vm._l((_vm.evaluationData), function(item, index) {
    return _c('div', [(index !== 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "areaTitle"
    }, [_c('table', {
      staticClass: "configArea"
    }, [_c('tr', {
      staticStyle: {
        "border-bottom": "1px solid #EBEEF5"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "#EDF1F2"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold",
        "padding-left": "10px",
        "line-height": "30px"
      }
    }, [_vm._v("\n                                                    评定项\n                                                ")])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "border-bottom": "1px solid #EBEEF5"
      }
    }, [_c('td', [_c('el-form-item', {
      attrs: {
        "label": "评定项名称"
      }
    }, [_vm._v("\n                                                                " + _vm._s(item.name) + "（" + _vm._s(item.radio) + "%）\n                                                            ")])], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-form', {
      attrs: {
        "label-position": "top"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "评定项说明"
      }
    }, [_vm._v("\n                                                                    " + _vm._s(item.content) + "\n                                                                ")])], 1)], 1)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#EDF1F2"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold",
        "padding-left": "10px",
        "line-height": "30px"
      }
    }, [_vm._v("\n                                                    评定项明细\n                                                ")])])])]), _vm._v(" "), _vm._l((item.list), function(i, subIndex) {
      return _c('table', {
        staticClass: "configArea"
      }, [_c('el-form-item', {
        attrs: {
          "label": "评定项明细名称"
        }
      }, [_vm._v("\n                                                    " + _vm._s(i.name) + "（" + _vm._s(i.upper) + "）\n                                                ")]), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "评定项明细说明"
        }
      }, [_vm._v("\n                                                    " + _vm._s(i.content) + "\n                                                ")]), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "成绩"
        }
      }, [_c('span', [_vm._v(_vm._s(i.score))])]), _vm._v(" "), _c('el-form-item', {
        attrs: {
          "label": "成绩评定说明"
        }
      }, [_c('span', [_vm._v(_vm._s(i.scoreContent))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "width": "35vh"
        }
      }, [_c('el-divider')], 1)], 1)
    }), _vm._v(" "), _c('table', {
      staticClass: "configArea"
    }, [_c('tr', {
      staticClass: "configRow"
    }, [_c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "width": "50%"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "总分"
      }
    }, [_c('span', [_vm._v(_vm._s(item.score))])])], 1)])])], 2)
  }), 0)], 1)])], 1)], 1) : _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "font-size": "18px",
      "font-weight": "bold",
      "color": "#a7a8ac",
      "margin-top": "10%"
    }
  }, [_vm._v("\n                        暂无成绩评定信息\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.previewerDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.fileName,
      "visible": _vm.previewerDialogVisible,
      "width": "90%",
      "top": "3vh",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.previewerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "680px"
    }
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "height": 650
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.summaryDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "visible": _vm.summaryDialogVisible,
      "width": "90%",
      "close-on-press-escape": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.summaryDialogVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.summaryDialogTitle))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.summaryDialogTitleDate))])]), _vm._v(" "), _c('div', {
    ref: "infoDialogScroll",
    staticStyle: {
      "height": "75vh",
      "overflow": "auto"
    },
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('summarys', {
    ref: "summary",
    attrs: {
      "summaryForm": _vm.summaryForm,
      "summaryFlag": _vm.summaryFlag,
      "dialogWidth": "90%",
      "userCode": this.user.userCode,
      "userType": "stu",
      "type": "mobile"
    },
    on: {
      "callback": _vm.summaryCallback
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.guidanceDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "现场指导",
      "visible": _vm.guidanceDialogVisible,
      "top": "50px"
    },
    on: {
      "update:visible": function($event) {
        _vm.guidanceDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "65vh",
      "overflow": "auto",
      "padding-right": "10px"
    }
  }, [_c('recordTable', {
    ref: "recordTable",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "user-type": "stu",
      "id": _vm.guidanceId,
      "dialogWidth": "90%",
      "type": "mobile"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.homecomingDetailDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "详情",
      "visible": _vm.homecomingDetailDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.homecomingDetailDialogVisible = $event
      }
    }
  }, [_c('div', {
    ref: "infoDialogScroll",
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('homecomingRecord', {
    ref: "homecomingRecord",
    attrs: {
      "user-code": _vm.user.userCode,
      "user-type": "stu",
      "dialogWidth": "90%",
      "type": "mobile",
      "id": _vm.homecomingId
    }
  }), _vm._v(" "), _c('br')], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "详情",
      "visible": _vm.notificationDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.notificationDialogVisible = $event
      }
    }
  }, [_c('div', {
    ref: "infoDialogScroll",
    staticStyle: {
      "height": "450px",
      "overflow": "auto"
    },
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationTitle))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发布时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationTime))])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationContent))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notificationDialogVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "通知公告",
      "id": "mainDialog",
      "visible": _vm.moreNotificationDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.moreNotificationDialogVisible = $event
      }
    }
  }, [_c('el-scrollbar', {
    ref: "infoDialogScroll",
    attrs: {
      "id": "infoDialogScroll"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "phoneList"
  }, [_c('div', {
    staticClass: "phoneListCard"
  }, _vm._l((_vm.notificationData), function(item, index) {
    return _c('div', {
      staticClass: "listCard"
    }, [_c('div', {
      staticClass: "listCardText"
    }, [_c('el-descriptions', {
      staticClass: "margin-top",
      attrs: {
        "title": "",
        "column": 1
      }
    }, [_c('el-descriptions-item', {
      attrs: {
        "label": "发布时间"
      }
    }, [_vm._v(_vm._s(item.time) + "\n                                            ")]), _vm._v(" "), _c('el-descriptions-item', {
      attrs: {
        "label": "标题"
      }
    }, [_vm._v(_vm._s(item.title) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "listCardBtn",
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "info",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.notificationDetail(item);
        }
      }
    }, [_vm._v("详情\n                                        ")])], 1)])
  }), 0)])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-366cd9ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/stuPracticeMobile.vue
// module id = 1810
// module chunks = 502